<template>
  <app-content>
    <info-report
      :report-data="reportData"
      :loading="loading"
      :is-default-chart="isDefaultChart"
      :hide-maneuvers-section="hideManeuversSection"
      @get-chart-data="getChartData"
      @show-help-modal="showHelpModal"
    >
      <slot name="chart-header-content" slot="chart-header-content" />
      <slot name="chart-header-buttons" slot="chart-header-buttons" />
      <slot name="chart-summary-row" slot="chart-summary-row" />
    </info-report>

    <b-row align-h="end" class="close-button-row">
      <b-button
        class="mt-3 no-internal-print close-button"
        variant="primary"
        @click="closeTab"
      >
        {{ $t('reports.oscillography.view-report.close') }}
      </b-button>
    </b-row>
    <help-modal ref="helpModal" />
  </app-content>
</template>
<script>
import InfoReport from './infoReport/index';
import HelpModal from './helpModal';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isDefaultChart: {
      type: Boolean,
      default: false,
    },
    hideManeuversSection: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HelpModal,
    InfoReport,
  },
  computed: {
    reportData() {
      return this.value;
    },
  },
  mounted() {
    const [element] = document.getElementsByClassName('app__content-wrapper');
    element.classList.add('force-overflow-y-scroll');
  },
  destroyed() {
    const [element] = document.getElementsByClassName('app__content-wrapper');
    element.classList.remove('force-overflow-y-scroll');
  },
  methods: {
    getChartData(filter) {
      this.$emit('refresh-chart', filter);
    },
    closeTab() {
      this.$confirmMessage({ code: 'MC022' }).accepted(() => window.close());
    },
    showHelpModal() {
      this.$refs.helpModal.show();
    },
  },
};
</script>

<style lang="sass" scoped>
  .close-button-row
    margin-right: 0 !important

  .close-button
    margin-right: 0 !important
</style>
